/**
 * Created by staffanrantzow on 02/11/16.
 */

import React, { PropTypes } from 'react';

class ToggleDisplay extends React.Component {

  static propTypes = {
    children: PropTypes.object.isRequired,
    show: PropTypes.bool
  };

  render () {
    return this.props.show ? this.props.children : null;
  }

}

export default ToggleDisplay;



/** WEBPACK FOOTER **
 ** ./src/components/toggle-display/toggle-display.js
 **/